import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ChatList from "../screens/ChatList";
import ChatUI from "../screens/ChatUI";
import "../styles/app.css";
import { useSelector } from "react-redux";

const Chats = () => {
  const [selectedChat, setSelectedChat] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [width, setWidth] = useState(window.innerWidth);
    const { loginStatus } = useSelector((state) => state?.auth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => { 

    if (width < 500 && location.pathname === "/auth/chatlist") {
      navigate("/auth/chats");
    } else if (width > 500 && location.pathname === "/auth/chats") {
      navigate("/auth/chatlist");
    }
  }, []); 

  const handleChatSelect = (chat) => {
    setSelectedChat(chat);
  };

  return (
    
    <div className="app-container">
      <div className="sidebar">
        <ChatList onSelectChat={handleChatSelect} title="Chats" />
      </div>

      <div className="chat-ui">
        {selectedChat ? (
          <ChatUI selectedChat={selectedChat} />
        ) : (
          <div className="centered-placeholder">
            <h4>Select a chat to start messaging</h4>
          </div>
        )}
      </div>
    </div>
  );
};

export default Chats;
